export {TestModule} from './src/test.module';
export {TestService} from './src/test.service';
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
